import React, { Component } from 'react'
import { Route } from 'react-router-dom'
import TipsPage from './ui/tipsPage/tipsPage'
import HomePage from './ui/homePage/homePage'
import SocialPage from './ui/socialPage/socialPage'
import ContactPage from './ui/contactPage/contactPage'


export default class App extends Component{

    render() {
        return(
            <div>
                <Route exact path={'/'} component={HomePage}/>
                <Route exact path={'/tips'} component={TipsPage}/>
                <Route exact path={'/social'} component={SocialPage}/>
                <Route exact path={'/contact'} component={ContactPage}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/App.js